import { SBack, SDrawerOrModal, SEditor, SGeneralForms, SMessage } from 'shj-components'
import styles from './index.module.less'
import { Button, Carousel, Col, Divider, Empty, Flex, message, Row, Space, Spin, Tabs } from 'antd'
import { useEffect, useRef, useState } from 'react'
import CheckButton from '@/components/CheckButton'
import { numFormat } from 'shj-components/dist/es/SFilterTable'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import ModifyStandard from '../components/modifyStandard'
import ContractModal from '@/components/ContractModal'
import { getBudgetPrintInfoMap } from '@/services/goods.ts'
import {
  chooseCheck,
  deleteQuoteBudgetDtl,
  listProductSkuRelationSpuFormat,
  queryProjectTree,
  quoteBudgetSelectQuoteBudgetInfo,
  updateBudgetField,
  updateDynaOptions,
  updatePackDtl,
  updateMaterialDynaOptions,
  listBudgetDtlSimple,
  checkTemplateUpdate,
} from '@/services/order'
import { useSetState, useUpdateEffect } from 'ahooks'
import _, { isArray, isEmpty } from 'lodash'
import KitDetailDialogV3 from '../components/KitDetailDialogV3'
import SkuDynamic from '../components/SkuDynamic'
import BudgetPrice from '../components/budgetPrice'
import ProductCard from '../components/ProductCard'
import { productManagementDetail, productSkuDetail } from '@/services/product'
import PDFPreview from '@/components/PDFPreview'
import ChooseMaterialModal from '@/components/ChooseMaterialModal'
import EmptyPng from '@/assets/empty.png'
import { getAuth } from '@/utils/btn.ts'
import ProductDetailDrawer from '@/components/ProductDetailDrawer'

export default function PoolingQuoteSelection() {
  const navigate = useNavigate()
  const { budgetId } = useParams() // 报价id
  const [dataSource, setDataSource] = useState<any>([])
  const budgetQtyFormularRef = useRef<any>(null)
  const [modifyStandardOpen, setModifyStandardOpen] = useState(false)
  const [modifyLoading, setModifyLoading] = useState<boolean>(false) // 修改规格loading
  const [currentModifyStandardArray, setCurrentModifyStandardArray] = useState<any>([]) // 当前修改规格数组
  const [treeChildrenItems, setTreeChildrenItems] = useState<any>([]) // 树形分类选中数据的子项
  const [lastChidrenItems, setLastChidrenItems] = useState<any>([]) // 项目子项或者子项的子项
  const [firstValue, setFirstValue] = useState<any>(null) // 通项数组第一行
  const [secondValue, setSecondValue] = useState<any>(null) // 通项数组第二行
  const [selectType, setSelectType] = useState<any>('') // 当前选材类型
  const [contractMap, setContractMap] = useState({})
  const [openContractModal, setOpenContractModal] = useState(false)
  const [refItemId, setRefItemId] = useState<any>('') // 记录当前分类或者项目的id
  const [quoteBudgetInfo, setQuoteBudgetInfo] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [budgetQtyFormularOpen, setBudgetQtyFormularOpen] = useState(false) // 预算量计算式弹窗
  const [recordItem, setRecordItem] = useState<any>(null) // 预算量计算式弹窗记录当前行数据
  const [recordInfo, setRecordInfo] = useState<any>(null) // 预算量计算式弹窗记录当前行数据
  const [skuList, setSkuList] = useState<any>([]) // 当前产品的sku map信息
  const [errorObj, setErrorObj] = useState<any>('') // 选材检查错误列表
  const [tabList, setTabList] = useState<any>([]) // 通项tab列表
  const [secondDefaultValue, setSecondDefaultValue] = useState<any>({}) // 通项数组第二行默认值
  const [qtyFormularLoading, setQtyFormularLoading] = useState(false) // 预算量计算式loading
  const [summaryAmountShowFlag, setSummaryAmountShowFlag] = useState<any>(false) // 汇总金额是否显示
  const summaryAmountFlagRef = useRef<any>(null)
  const [summaryAmount, setSummaryAmount] = useState<any>(0) // 汇总金额
  // 套件选择
  const [kitSku, setKitSku] = useState<any>({})
  const [kitSpu, setKitSpu] = useState<any>({})
  const [openKitDialog, setOpenKitDialog] = useState(false)
  const [combinationInfoList, setCombinationInfoList] = useState<any[]>([])
  const [packDtlList, setPackDtlList] = useState<any[]>([])
  const [activityInfo, setActivityInfo] = useState<any>({})

  // 动态属性
  const [skuDynamicOpen, setSkuDynamicOpen] = useState(false) // 动态属性弹窗
  const [skuDynamicVoList, setSkuDynamicVoList] = useState<any>([]) // 报价属性表单数据
  // 报价费用
  const [showPriceModule, setShowPriceModule] = useState(true)
  const auths = getAuth() || {}

  const priceTabList = [
    {
      value: '1',
      label: '费用明细',
      children: null,
    },
    {
      value: '2',
      label: '配置清单',
      children: null,
    },
  ]
  const [clickType, setClickType] = useState('')
  const [previewObj, setPreviewObj] = useSetState<any>({
    open: false,
    loading: false,
    descType: [],
    data: {},
  })
  const [openChooseMaterialModal, setOpenChooseMaterialModal] = useState(false)
  const [initFlag, setInitFlag] = useState(true)
  const budgetPriceRef = useRef<any>(null)
  useEffect(() => {
    checkUpdate()
  }, [])

  const checkUpdate = () => {
    console.log('初始化', initFlag)
    setLoading(true)
    if (initFlag) {
      checkTemplateUpdate({
        params: {
          budgetId: budgetId,
        },
      })
        .then((res: any) => {
          if (res?.requireUpdateFlag) {
            // 需要弹窗更新
            SMessage.confirm({
              title: `打包数据有更新，点击继续进行数据更新`,
              content: '该更新只对配置变更的数据更新，不会影响非变更数据的已有选材',
              okText: '继续',
              onOk: () => {
                return checkTemplateUpdate({
                  params: {
                    budgetId: budgetId,
                    updateFlag: true,
                  },
                })
                  .then((res: any) => {
                    init()
                    getTopData()
                  })
                  .catch((err: any) => {
                    goBack()
                  })
              },
              onCancel: () => {
                goBack()
              },
            })
          } else {
            init()
            getTopData()
          }
        })
        .finally(() => {
          setLoading(false)
          setInitFlag(false)
        })
    } else {
      init()
      getTopData()
    }
  }

  const onBudgetQtyFormularRef = () => {
    const { onFormRef } = budgetQtyFormularRef.current || {}
    return onFormRef?.()
  }
  useEffect(() => {
    summaryAmountFlagRef.current = summaryAmountShowFlag
  }, [summaryAmountShowFlag])
  const init = () => {
    getChildrenList()
  }
  const getTopData = () => {
    quoteBudgetSelectQuoteBudgetInfo({
      params: {
        quoteBudgetId: budgetId,
      },
    }).then((res: any) => {
      setQuoteBudgetInfo(res || {})
    })
  }

  // 3. 获取打包节点 项目 子项数据
  const getChildrenList = () => {
    queryProjectTree({
      params: {
        quoteBudgetId: budgetId,
        parentCode: 'CHOOSE',
      },
    }).then((res: any) => {
      if (isArray(res)) {
        res.unshift({
          label: '报价详情',
          type: 'PRD_SUB_ITEM',
          chooseFlag: false,
          summaryAmountDisplayFlag: false,
          requiredFlag: true,
          id: 'priceDetail',
          object: {
            showName: '报价详情',
          },
        })
        // 通项数据
        setTabList([...handleCheckButtonData(res)])
      }
    })
  }
  //  4.处理数据
  const handleCheckButtonData = data => {
    let newList: any = data.map((item: any) => {
      return {
        ...item,
        key: item.id,
        label: item?.object?.showName,
        text: item?.object?.showName,
        children: '',
        type: item.object.requiredFlag ? 'button' : 'checkbtn',
        checked: item.object.chooseFlag,
        status: '',
      }
    })
    return newList
  }
  const tabChange = (key: any) => {
    console.log(key)
    if (key === 'priceDetail') {
      setShowPriceModule(true)
    } else {
      let valueObj = tabList.find((item: any) => item.id === key)
      console.log(valueObj, 'valueObj')
      setFirstValue(valueObj)
      setShowPriceModule(false)
    }
  }
  useEffect(() => {
    // 如果包含子项则选中第二行数据
    if (firstValue) {
      // 判断是否有下级
      queryProjectTree({
        params: {
          quoteBudgetId: budgetId,
          prdCateId: firstValue.id,
        },
      }).then((res: any) => {
        if (res && res.length) {
          setLastChidrenItems([...handleCheckButtonData(res)])
          // setSecondValue(res[0])
        } else {
          setRefItemId(firstValue.id)
          fetchList(firstValue.id)
          setLastChidrenItems([])
          setSummaryAmountShowFlag(firstValue?.object?.summaryAmountDisplayFlag)
        }
      })
    }
  }, [firstValue])
  useUpdateEffect(() => {
    console.log(secondValue, 'secondValue')
    if (secondValue) {
      console.log(secondValue)
      setRefItemId(secondValue.id)
      fetchList(secondValue.id)
      setSummaryAmountShowFlag(secondValue?.object?.summaryAmountDisplayFlag)
    }
  }, [secondValue])

  // 6. 获取数据
  const fetchList = async (id?) => {
    setLoading(true)
    let locakSearch = {}
    return new Promise(async (resolve, reject) => {
      console.log(id, refItemId, 'id,refItemId')
      if (id || refItemId) {
        let resData: any
        try {
          resData = await listBudgetDtlSimple({
            id: budgetId,
            params: {
              spaceId: id || refItemId,
            },
          })
          console.log(resData, 'resData')
          getTotalPrice(resData)
          setDataSource([...resData])
          setLoading(false)
        } catch (err) {
          reject({ success: false })
          setLoading(false)
        }
      } else {
        reject({ success: false })
        setLoading(false)
      }
    })
  }
  // 显示项目合计金额
  const getTotalPrice = data => {
    let summaryAmount: number = 0 //统计总金额
    if (summaryAmountFlagRef.current) {
      data.forEach((el: any) => {
        if (!el.replaceFlag) {
          summaryAmount = Number(summaryAmount) + Number(el.budgetAmount ?? 0)
        }
      })
    }
    setSummaryAmount(summaryAmount)
  }
  //   表头render
  const toolbarTitle = (
    <div style={{ display: 'flex', alignItems: 'baseline' }} className={styles.orangeColor}>
      {summaryAmountFlagRef.current && (
        <>
          <span>合计金额：￥</span>
          <span className={styles.numberSize}>
            {summaryAmount ? numFormat({ value: summaryAmount }) : 0}
          </span>
        </>
      )}
    </div>
  )
  // 修改产品规格
  const handleEditDynamicProperties = async (item?: any) => {
    setModifyStandardOpen(true)
    setModifyLoading(true)
    setRecordItem(item)
    setRecordInfo(item)
    let dynaOptions
    let resData
    try {
      resData = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          productSpuId: item.prdId,
          generalId:
            selectType === 'UP_DOWN' || selectType === 'GENERAL'
              ? item?.generalItemManageId || null
              : null,
          priceCalcType: selectType === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId: item?.refActiveDtlId || null,
        },
      })
    } catch {
      setModifyLoading(false)
    }
    setModifyLoading(false)
    dynaOptions = item.dynaOptions
    setSkuList(resData.skuList)
    resData.specificationArgList?.map((item: any) => {
      if (!isEmpty(dynaOptions)) {
        item.argValId = dynaOptions[item.argCode].valueId
        item.argValName = dynaOptions[item.argCode].valueName
      }
      item.options = item.values?.map((ol: any) => {
        return {
          ...ol,
          argValId: ol.valueId,
          argValName: ol.valueName,
        }
      })
      return item
    })
    setCurrentModifyStandardArray(resData.specificationArgList || [])
  }

  // 确认规格回调
  const onSubmitModifyStandard = async value => {
    let selectObj = {}
    value.forEach((item: any) => {
      selectObj[item.argCode] = {
        argValId: item.argValId,
        argValName: item.argValName,
      }
    })
    let skuId: string = ''
    // 确定sku
    skuList.forEach((item: any) => {
      let flag = true
      for (let key in selectObj) {
        if (item.argMap[key].valueId !== selectObj[key].argValId) {
          flag = false
        }
      }
      if (flag) {
        skuId = item.id
      }
    })
    // 选材之后确定SKU码
    await updateDynaOptions({
      data: {
        quoteBudgetId: budgetId,
        quoteBudgetDtlId: recordItem.id,
        productSkuId: skuId,
        // dynaOptions: JSON.stringify(value || []),
      },
    })
    setModifyStandardOpen(false)
    getNewestPrice()
  }
  const handleEditBudgetQtyFormular = async (item?: any) => {
    setRecordItem(item)
    setBudgetQtyFormularOpen(true)
    onBudgetQtyFormularRef().setFieldsValue({
      remark: item.remark,
      budgetQtyFormular: item.standardFlag ? item.auditStandardQtyFormular : item.budgetQtyFormular,
      replaceNum: item.replaceNum,
    })
  }
  // 设置缓存值
  const toSetLocalData = (type, value) => {
    let localSearch: any = localStorage.getItem('quoteSelectionSearch') || '{}'
    localSearch = JSON.parse(localSearch || {})
    localSearch[type] = value
    localStorage.setItem('quoteSelectionSearch', JSON.stringify(localSearch || {}))
  }
  const onBudgetQtyFormularSubmit = async value => {
    setQtyFormularLoading(true)
    updateBudgetField({
      data: {
        id: recordItem.id,
        budgetId: budgetId,
        ...onBudgetQtyFormularRef().getFieldsValue(),
      },
    })
      .then(res => {
        setBudgetQtyFormularOpen(false)
        getNewestPrice()
      })
      .finally(() => {
        setQtyFormularLoading(false)
      })
  }
  // 删除产品
  const deleteSku = id => {
    SMessage.confirm({
      onOk: () => {
        if (id) {
          return deleteQuoteBudgetDtl({
            params: {
              id,
            },
          }).then((res: any) => {
            message.success(res.message || '操作成功')
            getNewestPrice()
          })
        }
      },
    })
  }

  /**
   * 产品明细功能函数
   * @name handleKitDetail  点击处理产品明细
   * @name closeKitDialog  关闭弹窗
   * @name confirmInfo  确认产品明细
   */

  // 套件
  const handleKitDetail = async item => {
    setOpenKitDialog(true)
    setRecordItem(item)
    setRecordInfo(item)
    setKitSku({})
    setKitSpu({})
    try {
      let resData: any = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          budgetDtlId: item.id,
          productSkuId: item.prdSkuId,
          productSpuId: item.prdId,
          generalId:
            selectType === 'UP_DOWN' || selectType === 'GENERAL'
              ? item?.generalItemManageId || null
              : null,
          priceCalcType: selectType === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId: item?.refActiveDtlId || null,
        },
      })
      let skuInfo = resData?.skuList?.find(el => el.id === item.prdSkuId) || []
      setKitSku(skuInfo)
      setKitSpu(resData)
      if (selectType === 'ACTIVITY') {
        setActivityInfo({
          activityId: item.refActiveId,
          activityProductId: item.refActiveDtlId,
        })
      }
      setPackDtlList(item.packDtlList || [])
    } catch (error) {}
  }
  const closeKitDialog = (value: any) => {
    setOpenKitDialog(false)
  }
  // 确认信息
  const confirmInfo = (combinationInfoDetail: any, combinationPrice) => {
    // 更新packDtl
    updatePackDtl({
      data: {
        budgetDtlId: recordItem.id,
        packDtlList: combinationInfoDetail.filter(el => el.selectSkuId && el.checked),
      },
    }).then(res => {
      message.success('更新成功')
      getNewestPrice()
    })
  }
  // 修改报价属性
  const handleEditSkuDynamicVoList = (item?: any) => {
    setSkuDynamicOpen(true)
    let skuDynamicVoList = item.skuDynamicVoList.map(el => {
      let materialDynaOptions = item.materialDynaOptions?.find(item => item.id === el.id) || null
      if (materialDynaOptions) {
        el.optionId = materialDynaOptions.optionId
        el.optionName = materialDynaOptions.optionName
      }
      return el
    })
    setRecordItem(item)
    setSkuDynamicVoList(skuDynamicVoList)
  }
  const onSubmitSkuDynamicVoList = async value => {
    // 更新动态属性
    updateMaterialDynaOptions({
      data: {
        budgetDtlId: recordItem.id,
        materialDynaOptions: value,
      },
    }).then(res => {
      message.success('更新成功')
      getNewestPrice()
    })
  }

  const handleSubmitContract = async () => {
    try {
      if (budgetId) {
        const res = await getBudgetPrintInfoMap([budgetId])
        setContractMap(res || {})
        setOpenContractModal(true)
      } else {
        message.error('无报价ID')
      }
    } catch (err) {
      console.log(err)
    }
  }
  const goBack = () => {
    localStorage.removeItem('quoteSelectionSearch')
    history.back()
  }
  const checkMaterial = () => {
    // 选材检查
    chooseCheck({
      params: {
        budgetId: budgetId,
      },
    }).then(res => {
      setErrorObj(res)
      message.success('选材检查完成')
    })
  }
  const getNewestPrice = () => {
    // 刷新价格
    getTopData()
    fetchList()
  }
  useEffect(() => {
    // 检查报错项目
    if (errorObj) {
      let newTreeChildItems = _.cloneDeep(treeChildrenItems)
      let newLastChidrenItems = _.cloneDeep(lastChidrenItems)
      // 添加项目报错提示
      if (newTreeChildItems && newTreeChildItems.length) {
        newTreeChildItems.map((item: any) => {
          if (errorObj.itemIdList?.includes(item.id)) {
            item.status = 'danger'
          }
          return item
        })
        setTreeChildrenItems([...newTreeChildItems])
      }
      if (newLastChidrenItems && newLastChidrenItems.length) {
        newLastChidrenItems.map((item: any) => {
          if (errorObj.itemIdList?.includes(item.id)) {
            item.status = 'danger'
          }
          return item
        })
        setLastChidrenItems([...newLastChidrenItems])
      }
    }
  }, [errorObj])
  const onOpenProductDetail = productId => {
    setPreviewObj({ open: true, loading: true })
    productSkuDetail(productId)
      .then(res => {
        setPreviewObj({
          data: res,
        })
      })
      .finally(() => setPreviewObj({ loading: false }))
  }
  const addNewMaterial = () => {
    setOpenChooseMaterialModal(true)
  }
  // 根据点击类型触发事件
  const btnClick = (val: string, item: any) => {
    console.log(item)
    setClickType(val)
    switch (val) {
      case 'BudgetQty':
        // 预算量
        handleEditBudgetQtyFormular(item)
        break
      case 'replace':
        // 替换量
        handleEditBudgetQtyFormular(item)
        break
      case 'remark':
        // 备注
        handleEditBudgetQtyFormular(item)
        break
      case 'modifyDynamic':
        // 修改规格
        handleEditDynamicProperties(item)
        break
      case 'productDetail':
        // 产品明细
        handleKitDetail(item)
        break
      case 'SkuDynamic':
        // 报价属性
        handleEditSkuDynamicVoList(item)
        break
      case 'delete':
        // 删除
        // 若是删除替换产品 要掉替换量修改接口
        if (item.replaceFlag) {
          let dialog = SMessage.delete({
            onOk: () => {
              updateBudgetField({
                data: {
                  id: item.id,
                  budgetId: budgetId,
                  replaceNum: 0,
                },
              })
                .then(res => {
                  getNewestPrice()
                  dialog?.destroy()
                })
                .finally(() => {
                  dialog?.destroy()
                })
            },
            onCancel: () => {
              message.warning('取消删除')
              dialog?.destroy()
            },
          })
        } else {
          deleteSku(item.id)
        }
        break
      case 'preview':
        // 查看详情
        if (item.errMessage) return
        onOpenProductDetail(item.prdSkuId)
        break
      default:
        break
    }
  }
  return (
    <SBack
      title={'预算详情'}
      level={2}
      goPath={goBack}
      gutter={0}
      extra={[
        <div className={styles.btns}>
          {!loading && (
            <div className="flex-center">
              <Space split={<Divider type="vertical" />} style={{ marginRight: 30 }}>
                <span>{quoteBudgetInfo?.customerName}</span>
                <span>{quoteBudgetInfo?.quoteGoodsName}</span>
                <span>{quoteBudgetInfo?.typeDisplay}</span>
              </Space>
              <span className={styles.orangeColor}>合同金额：￥</span>
              <span className={`${styles.orangeColor}  ${styles.numberSize}`}>
                {quoteBudgetInfo?.contractAmount
                  ? numFormat({ value: quoteBudgetInfo?.contractAmount })
                  : '0.00'}
              </span>
              <Space>
                <Button style={{ marginLeft: 10 }} onClick={getNewestPrice}>
                  刷新价格
                </Button>
                {quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag && (
                  <Button onClick={checkMaterial}>选材检查</Button>
                )}
                <Button type="primary" onClick={addNewMaterial}>
                  新增选材
                </Button>
                {auths['starting_contract'] && (
                  <Button type="primary" onClick={handleSubmitContract}>
                    发起合同
                  </Button>
                )}
              </Space>
            </div>
          )}
        </div>,
      ]}
    >
      <Spin spinning={loading} wrapperClassName="base-spin-wrapper">
        <div className={styles.baseBox}>
          <div className={styles.contentBox}>
            {/* 顶部 通项/项目选择 */}
            <div className={styles.tableContent}>
              <Tabs items={tabList} onChange={tabChange} defaultActiveKey="priceDetail" />
              {showPriceModule ? (
                <BudgetPrice
                  reloadList={() => {
                    getTopData()
                    init()
                  }}
                  couldEdit={
                    quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag
                  }
                  quoteBudgetInfo={quoteBudgetInfo}
                  priceTabList={priceTabList}
                  ref={budgetPriceRef}
                ></BudgetPrice>
              ) : (
                <>
                  {lastChidrenItems && lastChidrenItems.length > 0 && (
                    <div className={styles.projectBox}>
                      <CheckButton
                        key={lastChidrenItems}
                        data={lastChidrenItems}
                        setCurrentValue={val => {
                          setSecondValue({ ...val })
                        }}
                        defaultValue={secondDefaultValue}
                        level={2}
                        budgetId={budgetId}
                      ></CheckButton>
                    </div>
                  )}

                  {/* 金额展示 */}
                  <div className={styles.toolbarTitleBox}>{toolbarTitle}</div>
                  {/* 选材表格 */}
                  {dataSource?.length > 0 ? (
                    <Flex wrap gap="15px" className={styles.cardPlayBox}>
                      {dataSource?.map((item: any) => {
                        return (
                          <div className={styles.cardPlaySingleBox}>
                            <ProductCard
                              item={item}
                              btnClick={val => {
                                btnClick(val, item)
                              }}
                            ></ProductCard>
                          </div>
                        )
                      })}
                    </Flex>
                  ) : (
                    <div className={styles.emptyBox}>
                      <Empty
                        image={EmptyPng}
                        imageStyle={{
                          width: 400,
                          height: 300,
                        }}
                        description={null}
                      ></Empty>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {/* 产品明细 */}
          {openKitDialog && (
            <KitDetailDialogV3
              kitSku={kitSku}
              setKitSku={setKitSku}
              productInfo={kitSpu}
              open={openKitDialog}
              closeDialog={closeKitDialog}
              confirmInfo={confirmInfo}
              combinationInfoList={combinationInfoList}
              packDtlList={packDtlList}
              selectType={selectType}
              activityInfo={activityInfo}
              generalId={recordInfo.generalItemManageId}
              recordItem={recordItem}
            />
          )}

          {/* 修改规格 */}
          <ModifyStandard
            open={modifyStandardOpen}
            onCancel={() => {
              setModifyStandardOpen(false)
            }}
            loading={modifyLoading}
            formList={currentModifyStandardArray}
            title="选择规格"
            onSubmit={onSubmitModifyStandard}
            skuList={skuList}
            okText="确定"
          ></ModifyStandard>
          {/* 发起合同 */}
          {openContractModal && (
            <ContractModal
              open={openContractModal}
              closeDialog={() => setOpenContractModal(false)}
              contractMap={contractMap}
            />
          )}
          <SDrawerOrModal
            mode="modal"
            open={budgetQtyFormularOpen}
            loading={qtyFormularLoading}
            onCancel={() => setBudgetQtyFormularOpen(false)}
            styles={{ body: { padding: '0 15px' } }}
            onOk={onBudgetQtyFormularSubmit}
            width={400}
            title={
              {
                BudgetQty: '预算量',
                remark: '备注',
                replace: '替换量',
              }[clickType]
            }
          >
            <SGeneralForms
              ref={budgetQtyFormularRef}
              layout={'vertical'}
              configs={[
                {
                  formItem: [
                    {
                      label: '预算量计算式',
                      name: 'budgetQtyFormular',
                      spanCol: 24,
                      comConfig: {
                        disabled: !recordItem?.updateFormularFlag,
                      },
                      isDeps: true,
                      deps: () => clickType === 'BudgetQty',
                    },
                    {
                      label: '备注',
                      name: 'remark',
                      spanCol: 24,
                      isDeps: true,
                      deps: () => clickType === 'remark',
                      type: 'textarea',
                      comConfig: {
                        maxLength: 200,
                        showCount: true,
                      },
                    },
                    {
                      label: '替换量',
                      name: 'replaceNum',
                      spanCol: 24,
                      isDeps: true,
                      deps: () => clickType === 'replace',
                      type: 'inputNumber',
                    },
                  ],
                },
              ]}
            />
          </SDrawerOrModal>

          {/* 动态属性 */}
          <SkuDynamic
            open={skuDynamicOpen}
            onCancel={() => {
              setSkuDynamicOpen(false)
            }}
            loading={false}
            formList={skuDynamicVoList}
            title="报价属性"
            onSubmit={onSubmitSkuDynamicVoList}
          ></SkuDynamic>
        </div>
     
        {previewObj.open && (
          <ProductDetailDrawer
            previewObj={previewObj}
            setPreviewObj={setPreviewObj}
          ></ProductDetailDrawer>
        )}

        {openChooseMaterialModal && (
          <ChooseMaterialModal
            open={openChooseMaterialModal}
            onClose={() => setOpenChooseMaterialModal(false)}
            reloadList={() => {
              getNewestPrice()
              budgetPriceRef?.current?.init()
            }}
          />
        )}
      </Spin>
    </SBack>
  )
}
